import { POSTHOG_FEATURE_FLAGS, useFeatureFlagsReady, usePostHogFeatureFlag } from '../usePostHogFeatureFlag'
import { usePermissions } from '../usePermissions'

import { UseOrganisationsAccessReturn } from './useOrganisationsAccess.types'

// Flag on: each control follows its `organisations` permission; flag off: the `ad_*` flag it had before.
// Image upload follows `organisation_profiles` instead, because that is the domain its endpoint enforces.
export function useOrganisationsAccess(): UseOrganisationsAccessReturn {
  const { userHasPermissions } = usePermissions()
  const flagsReady = useFeatureFlagsReady()

  const organisationsFga = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.INTERNAL_FGA_ORGV_ORGANISATIONS)
  const organisationProfilesFga = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.INTERNAL_FGA_ORGV_ORGANISATION_PROFILES)

  const editOfficialDetails = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_EDIT_OFFICIAL_DETAILS)
  const editRegistrationStatus = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_EDIT_REGISTRATION_STATUS)
  const editBrandDetails = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_EDIT_BRAND_DETAILS)
  const editContactsDetails = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_EDIT_CONTACTS_DETAILS)
  const editLocationDetails = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_EDIT_LOCATION_DETAILS)
  const uploadOrgImages = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_UPLOAD_ORG_IMAGES)
  const unclaimOrg = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_EDIT_UNCLAIM_ORG)
  const batchUpdateOrganisations = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_BATCH_UPDATE_ORGANISATIONS)

  const gate = (fgaEnabled: boolean, permission: string, legacyFlag: boolean) =>
    flagsReady && (fgaEnabled ? userHasPermissions(permission) : legacyFlag)

  const canUpdate = (legacyFlag: boolean) => gate(organisationsFga, 'organisations:can_update', legacyFlag)

  return {
    canEditOfficialDetails: canUpdate(editOfficialDetails),
    canEditRegistrationStatus: canUpdate(editRegistrationStatus),
    canEditBrand: canUpdate(editBrandDetails),
    canEditContacts: canUpdate(editContactsDetails),
    canEditLocation: canUpdate(editLocationDetails),
    canUploadImages: gate(organisationProfilesFga, 'organisation_profiles:can_upload_image', uploadOrgImages),
    canUnclaim: gate(organisationsFga, 'organisations:can_unclaim', unclaimOrg),
    canBatchUpdate: gate(organisationsFga, 'organisations:can_batch_update', batchUpdateOrganisations),
    canUpdateOrganisation: canUpdate(true)
  }
}
